import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppConfig } from 'src/app/app.config';
import { ILinkSettings } from 'src/app/models/app-config.model';
import { Features } from 'src/app/models/features';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  HostListener,
} from '@angular/core';

@UntilDestroy()
@Component({
  selector: 'public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
})

export class PublicHeaderComponent implements OnInit {

  contactUs: string;
  aboutUs: string;
  createNewAccountLink: string;
  createNewAccountLinkText: string;

  constructor(private appConfig: AppConfig) {
    const links: ILinkSettings = this.appConfig.getLinks();
    this.contactUs = links.contactUs;
    this.aboutUs = links.aboutUs;

    const signInSection = this.appConfig.getSection(Features.SIGN_IN) || {};
    this.createNewAccountLink = signInSection.createNewAccountLink ?? "";
    this.createNewAccountLinkText = signInSection.createNewAccountLinkText ?? "Join";
  }

  ngOnInit() {
  }

}
